export const BROADCAST_SPOT_LENGTH_MIN = 1;
export const BROADCAST_SPOT_LENGTH_MAX = 3000;
export const BROADCAST_SPOT_LENGTH_DEFAULT = 10;
